import { render, staticRenderFns } from "./UpdateRerConfig.vue?vue&type=template&id=21b6af08&scoped=true"
import script from "./UpdateRerConfig.vue?vue&type=script&lang=js"
export * from "./UpdateRerConfig.vue?vue&type=script&lang=js"
import style0 from "./UpdateRerConfig.vue?vue&type=style&index=0&id=21b6af08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6af08",
  null
  
)

export default component.exports